var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.current_clinic && _vm.loaded_grid)?_c('sub-regimen',{attrs:{"show_title":true,"title":_vm.loaded_grid.description,"regimen_override":_vm.regimen,"exercises":_vm.exercises,"video_exercises":_vm.video_exercises,"user":_vm.current_user,"clinic":_vm.current_clinic,"invite_id":'',"show_start_arrow":false,"ephemeral":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }